import { Component, forwardRef, Input } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AuftragGrundstueckTypAuswahlMeta } from 'app/core/batch-auftrag-api';
import { GrundstueckTypAuswahl } from 'app/core/gb-api';
import { AtLeastOneValidatorDirective } from '../../validators/at-least-one-validator.directive';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import SucheSdrUnterartEnum = GrundstueckTypAuswahl.SucheSdrUnterartEnum;

@Component({
  selector: 'cap-auftrag-grundstuecktype-selection',
  templateUrl: './auftrag-grundstuecktype-selection.component.html',
  styleUrls: ['./auftrag-grundstuecktype-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragGrundstueckSelectionComponent),
      multi: true
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [
    AtLeastOneValidatorDirective,
    FormsModule,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class AuftragGrundstueckSelectionComponent implements ControlValueAccessor {
  @Input() heading = 'Grundstuecksart';

  @Input()
  disabled: boolean;

  model: AuftragGrundstueckTypAuswahlMeta;
  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor(private translate: TranslateService) {
    keysToTranslate<string>(['Folio', 'EingabeMussMindestensEinGrundstueckTypAusgewaehltHaben']);
  }

  writeValue(obj: AuftragGrundstueckTypAuswahlMeta): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  getUnterart(value: SucheSdrUnterartEnum | null) {
    if (!value) {
      return '';
    }
    return this.translate.instant(value);
  }
}
